import { useRef } from 'react';

const buildTabs = (tabs) => (tabs.map((tab) => ({
  ...tab,
  titleRef: useRef(),
  sectionRef: useRef(),
})));

export default buildTabs;
